import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import {MODULE, PageProps, PERMISSION} from "core/metamodel/metaConstant";
import mdEntityService from "core/metamodel/mdEntityService";
import {observer} from "mobx-react";
import {loc} from "core/common/config/locales";
import "shipment/page/shipmentRepackagingList.less";
import {PAGE} from "routes";
import {ZzFlatButtonRoute} from "core/components/buttons/buttons";

const gridLocation = 'shipmentVisitList';


@observer
export default class ShipmentVisitList extends PageAncestor<PageProps, undefined> {

  static module = MODULE.shipment;
  static title = loc.i18n`Shipment visits`;
  static icon = 'blind';
  static rootPage = true;
  static protectedPage = true;


  static fetchData(routerParams) {
    console.log("ShipmentVisitList#fetchData(%s)", gridLocation);

    return gridService.fetchGrids(gridLocation)
      .then(gridLocationMap => {
        return gridService.getOrCreateGrid(gridLocation);
      });
  }







  render() {
    let {params, query} = this.props;


    return (
      <GridCompConnected grid={gridService.getOrCreateGrid(gridLocation)} entities={mdEntityService.entityMap} gridId={params.gridId} query={query} refreshEntities={["Shipment", "ShipmentVisit"]}>
        <ZzFlatButtonRoute onGridToolbar routeName="shipmentVisitDetail" params={{id: 'new'}} label={loc.i18n`New Shipment visit`} permission={PERMISSION.New} securable={PAGE.shipmentVisitDetail}/>
      </GridCompConnected>
    );
  }


}



// WEBPACK FOOTER //
// ./src/shipment/page/shipmentVisitList.tsx